import { createContext, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';
const AnalyticsContext = /*#__PURE__*/createContext({
  analyticsPrefix: ''
});
const useAnalyticsContext = () => {
  return useContext(AnalyticsContext);
};
function AnalyticsProvider({
  children,
  analyticsPrefix
}) {
  const _useAnalyticsContext = useAnalyticsContext(),
    _useAnalyticsContext$ = _useAnalyticsContext.analyticsPrefix,
    parentAnalyticsPrefix = _useAnalyticsContext$ === void 0 ? '' : _useAnalyticsContext$;
  return /*#__PURE__*/jsx(AnalyticsContext.Provider, {
    value: {
      analyticsPrefix: `${parentAnalyticsPrefix}${parentAnalyticsPrefix && analyticsPrefix ? '-' : ''}${analyticsPrefix}`
    },
    children: children
  });
}
export { AnalyticsProvider, useAnalyticsContext };
//# sourceMappingURL=AnalyticsProvider.js.map
